import type { ApiResponse } from '@creator/sdk/creator-sdk';
import type { ReportDB, UpdateReportPayload } from '@creator/sdk/modules/report/report.model';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';
import { updateReport as updateReportAtom } from './reports';

export const updateReportStatus = async (payload: UpdateReportPayload): Promise<ReportDB> => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<ReportDB>>(
        '/report/update',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': await creatorSdk.appCheckModule.getAppCheckToken(),
        },
        false
    );

    const updatedReport = data.payload;

    // Update atom with new status
    updateReportAtom(payload.reportId, { status: updatedReport.status });

    return updatedReport;
};
